function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M 12.43679,51.537083 V 6.6346922 h 15.166889 q 8.621176,0 11.23946,0.6738424 4.023216,1.0107627 6.737292,4.4106024 2.714074,3.369211 2.714074,8.729318 0,4.134944 -1.564586,6.952826 -1.564583,2.817888 -3.991288,4.441229 -2.394771,1.592721 -4.885331,2.113415 -3.384613,0.643214 -9.802599,0.643214 H 21.888158 V 51.537083 Z M 21.888158,14.23073 v 12.741743 h 5.172702 q 5.587802,0 7.471689,-0.704473 1.883887,-0.704468 2.937589,-2.205302 1.085626,-1.500828 1.085626,-3.491728 0,-2.450335 -1.500719,-4.043051 -1.500726,-1.592717 -3.799708,-1.990897 -1.692306,-0.306292 -6.801152,-0.306292 z",
  id: "path228"
});

function SvgParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56.9 56.9",
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.fa41d382.svg";
export { ForwardRef as ReactComponent };